export const LogoMark = ({ size = 36, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <circle cx="32" cy="32" r="29" stroke="#F6F4EE" strokeWidth="1" />
    <path
      d="M 15.66 26.55 A 20 20 0 0 1 26.55 15.66"
      stroke="#F6F4EE"
      strokeWidth="1"
      strokeLinecap="round"
    />
    <path
      d="M 48.34 37.45 A 20 20 0 0 1 37.45 48.34"
      stroke="#F6F4EE"
      strokeWidth="1"
      strokeLinecap="round"
    />
  </svg>
);

export const Wordmark = ({ className = "" }) => (
  <span
    className={`font-serif tracking-[0.08em] text-dealer-ivory ${className}`}
  >
    DE<span className="text-dealer-burgundybright">A</span>LER
  </span>
);
